import React, { Component } from "react"

import { Link } from "gatsby"

import headerStyles from "./header.module.scss"

const Header = props => {
  const { siteLogo, logoText } = props
  return (
    <header className={headerStyles.header}>
      <Link to="/">
        <div className={headerStyles.logo}>
          {siteLogo.src ? (
            <img src={siteLogo.src} alt={siteLogo.alt} />
          ) : (
            <>
              <span className={headerStyles.mark}>#</span>
              <span className={headerStyles.text}>{logoText}</span>
              <span className={headerStyles.cursor} />
            </>
          )}
        </div>
      </Link>

      <ul className={headerStyles.navList}>
        <li>
          <Link
            to="/htb"
            className={headerStyles.navItem}
            activeClassName={headerStyles.activeNavItem}
          >
            HTB
          </Link>
        </li>
        <li>
          <Link
            to="/ctf"
            className={headerStyles.navItem}
            activeClassName={headerStyles.activeNavItem}
          >
            CTF
          </Link>
        </li>
        <li>
          <Link
            to="/blog"
            className={headerStyles.navItem}
            activeClassName={headerStyles.activeNavItem}
          >
            Blog
          </Link>
        </li>
      </ul>
    </header>
  )
}

export default Header
